@if (esAdmin && !esSoporte && $enPaginaClientesBackOffice | async) {
<button
  class="tw-mx-2"
  nzTooltipTitle="Dashboard"
  nzTooltipPlacement="bottom"
  nz-tooltip
  nz-button
  nzType="link"
  nzShape="circle"
  type="button"
  aria-label="Ir al dashboard"
  (click)="onGoDashboard()"
>
  <i class="fa-solid fa-arrow-left-to-line"></i>
</button>
} @if (esAdmin && ($enPaginaClientesBackOffice | async) !== true) {
<button
  class="tw-mx-2"
  nzTooltipTitle="BackOffice Clientes"
  nzTooltipPlacement="bottom"
  nz-tooltip
  nz-button
  nzType="link"
  nzShape="circle"
  type="button"
  aria-label="Ir al BackOffice de clientes"
  (click)="onGoPaginaClientesBackOffice()"
>
  <i class="fa-solid fa-cog"></i>
</button>
}
